import { render, staticRenderFns } from "./pembuatan_tabel_peta_znt.vue?vue&type=template&id=283f51b6&"
import script from "./pembuatan_tabel_peta_znt.vue?vue&type=script&lang=js&"
export * from "./pembuatan_tabel_peta_znt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports